import { apiLogout } from '../api/api.js';

let logout = () => {
    localStorage.removeItem('access_token');
    apiLogout()
        .then(res => {
            if (res.ok) {
                window.location.href = '/';
            } else {
                res.json().then(json => {
                    alert(`Logout failed, please reach out to ramsey.opp@gmail.com: ${json.description}`);
                });
            }
        })
        .catch(error => {
            console.error('Error during logout, please reach out to ramsey.opp@gmail.com:', error)
        });
};

export { logout };
